export const base_url = "https://backend.afya.chat";
export const org_id = "e4b23ff0-7d77-11ec-8d54-d5a35697a8d6";
